import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AnchorModule } from '@finder/shared/components/anchor/anchor.module';
import { ButtonModule } from '@finder/shared/components/button/button.module';
import { FontIconModule } from '@finder/shared/components/font-icon/font-icon.module';
import { JoinModule } from '@finder/shared/utils/pipes/join/join.module';
import { MapCardComponent } from '@finder/shared/components/map-card/map-card.component';
import { MapCardService } from '@finder/shared/services/map-card/map-card.service';
import { MapComponent } from './map.component';
import { MapDefaultsService } from './defaults/map.defaults.service';
import { MapFactoryService } from './map/map.factory.service';
import { MapHelpers } from './map.helpers';
import { MouseIntentService } from '@finder/shared/services/mouse-intent/mouse-intent.service';
import { OperatingStatusComponent } from '../operating-status/operating-status.component';
import { PictureModule } from '@finder/shared/components/picture/picture.module';
import { PremierAccessComponent } from '@finder/shared/components/premier-access/premier-access.component';

@NgModule({
    imports: [
        AnchorModule,
        ButtonModule,
        CommonModule,
        FontIconModule,
        JoinModule,
        OperatingStatusComponent,
        PictureModule,
        PremierAccessComponent,
    ],
    declarations: [
        MapComponent,
        MapCardComponent,
    ],
    providers: [
        MapDefaultsService,
        MapFactoryService,
        MapHelpers,
        MapCardService,
        MouseIntentService,
    ],
    exports: [
        MapComponent,
        MapCardComponent,
    ]
})
export class MapModule {
    static entry = MapComponent;
}
